export enum BuildingInfoDatasource {
  None,
  OrderingService,
  GeoService,
  Oodit
}
